import CreateTextCell from 'common/components/grid/cells/CreateTextCell'
import { validateUrl } from 'common/utils/validate'

export const cellUrl = {
	component: CreateTextCell,
	config: {
		alignRight: false,
		formatBlurredInput: ({ value, typeProps }) => (value ? value : ''),
		formatCopyValue: ({ value, typeProps }) => (value ? value : ''),
		parseUserInput: ({ value, typeProps }) => {
			if (!value || value.length < 1) return null
			const newValue = value.trim()
			const validation = validateUrl(newValue)
			return validation.valid ? validation.url : null
		},
		parsePastedValue: ({ value, typeProps, localeFallback }) => {
			if (!value || value.length < 1) return null
			const newValue = value.trim()
			const validation = validateUrl(newValue)
			return validation.valid ? validation.url : null
		}
	}
}
